import { FC } from "react";
import { TableBody } from "@mui/material";
import { ResourceTypeCoverage } from "@/services/cloudchipr.api";
import { CommitmentsOverviewCoverageTableRow } from "@/components/pages/commtiments/overview/content/components/common/coverage-table/CommitmentsOverviewCoverageTableRow";

interface CommitmentsOverviewCoverageTableBodyProps {
  data: ResourceTypeCoverage[] | null;
}

export const CommitmentsOverviewCoverageTableBody: FC<
  CommitmentsOverviewCoverageTableBodyProps
> = ({ data }) => {
  return (
    <TableBody sx={{ pt: 1 }}>
      {data?.map((item) => (
        <CommitmentsOverviewCoverageTableRow
          key={item.resource_type + item.uncovered_usage + item.coverage}
          resourceCoverageItem={item}
        />
      ))}
    </TableBody>
  );
};
